export default __webpack_public_path__ + "static/whatWeDo1-aa25b8f30c2ac5b3a1430f047948c841.webp";